<template>
  <khrc-navbar/>
  <data-science-component />
</template>

<script>
// @ is an alias to /src
import KhrcNavbar from "@/components/KhrcNavbar.vue";
import DataScienceComponent from "@/components/DataScienceComponent.vue";

export default {
  name: "HomeView",
  components: {
    KhrcNavbar,
    DataScienceComponent,
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  },
};
</script>
